"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrepJobCreationSource = void 0;
exports.PrepJobCreationSource = {
    SELLER_PORTAL: "SELLER_PORTAL",
    MANUAL: "MANUAL",
    SFN_APP: "SFN_APP",
};
//# sourceMappingURL=prep-job-creation-source.js.map